import { Accordion, AccordionContent, AccordionItem, AccordionTrigger, Card, CardContent } from 'app-template-lib/components/shadcn';

/**
 * 利用規約
 * @returns
 */
export default function About(props: { lgcode: string }) {
    const { lgcode } = props;
    return (
        <div className="flex justify-center items-center px-4">
            <Card className="w-full p-6">
                <h2 className="text-2xl font-bold mb-4">本サイトについて</h2>

                <CardContent className="p-4 h-full overflow-y-auto bg-white rounded">
                    <div className="container mx-auto p-4 max-w-4xl">
                        <section className="mb-6">
                            <h2 className="text-xl font-semibold mb-2">1. まちの事業マップ</h2>
                            <Card className="shadow-none border-none bg-slate-50">
                                <CardContent className="p-4">
                                    <p>当ウェブサイトは、琴浦町の計画や取り組みを知り、意見を届けられるプラットフォームです。</p>
                                    予算の説明書や、決算の説明書をこれまでＰＤＦデータで、ホームページ当に掲載してきましたが、
                                    税金がどんなことに使われているかが分からない、必要な情報を見つけられないといった意見を頂いてきました。{' '}
                                    <br />
                                    本サイトでは、琴浦町が将来この町をどのようなまちにしようとしているのか、そのためにどのような事業を行っているのかを
                                    町民が検索できる形で公開しています。
                                </CardContent>
                            </Card>
                        </section>

                        <section className="mb-6">
                            <h2 className="text-xl font-semibold mb-2">2. サービスの目的と特徴</h2>
                            <Card className="shadow-none border-none bg-slate-50">
                                <CardContent className="p-4">
                                    <p>計画の見える化</p>
                                    <p>データの公開</p>
                                    <p>住民の意見投稿(coming soon...)</p>
                                </CardContent>
                            </Card>
                        </section>

                        <section className="mb-6">
                            <h2 className="text-xl font-semibold mb-2">3. 使い方（利用の流れ）</h2>

                            <Card className="shadow-none border-none bg-slate-50">
                                <CardContent className="p-4">
                                    <p>
                                        計画をチェック（市町村の施策・事業を閲覧）
                                        <br />
                                        意見を投稿（気になる計画にコメントや提案を記入） ※coming soon...
                                        <br />
                                        みんなの意見を確認（他の住民の意見も参考にできる） ※coming soon...
                                        <br />
                                        行政のフィードバック（自治体が意見を反映した場合、通知が届く）※coming soon...
                                    </p>
                                </CardContent>
                            </Card>
                        </section>

                        <section className="mb-6">
                            <h2 className="text-xl font-semibold mb-2">4. よくある質問（FAQ）</h2>

                            <Card className="shadow-none border-none bg-slate-50">
                                <CardContent className="p-4">
                                    <Accordion type="single" collapsible className="w-full bg-slate-50">
                                        <AccordionItem value="item-1">
                                            <AccordionTrigger className="bg-slate-50">投稿した意見は誰が見られますか？</AccordionTrigger>
                                            <AccordionContent>公開され、他の住民も閲覧できます。</AccordionContent>
                                        </AccordionItem>
                                        <AccordionItem value="item-2">
                                            <AccordionTrigger className="bg-slate-50">匿名で投稿できますか？</AccordionTrigger>
                                            <AccordionContent>ニックネームで投稿可能です。</AccordionContent>
                                        </AccordionItem>
                                        <AccordionItem value="item-3">
                                            <AccordionTrigger className="bg-slate-50">
                                                行政はすべての意見に回答してくれますか？
                                            </AccordionTrigger>
                                            <AccordionContent>
                                                すべてに対応するわけではありませんが、重要な意見は検討の対象になります。
                                            </AccordionContent>
                                        </AccordionItem>
                                    </Accordion>
                                </CardContent>
                            </Card>
                        </section>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
}
